import { useTranslation } from 'react-i18next';
import { Close } from 'qampo-ui-library';
import SaveIcon from '../../assets/icons/save.svg?react';
import styles from './EditableCell.module.css';

interface EditingActionsProps {
  canSave: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const EditingActions = ({ canSave, onSave, onCancel }: EditingActionsProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.editWrapper}>
      <button
        type="button"
        className={`${styles.iconButton} ${styles.save}`}
        disabled={!canSave}
        onClick={onSave}
        aria-label={t('save')}
        title={t('save')}
      >
        <SaveIcon />
      </button>
      <button
        type="button"
        className={`${styles.iconButton} ${styles.cancel}`}
        onClick={onCancel}
        aria-label={t('cancel')}
        title={t('cancel')}
      >
        <Close />
      </button>
    </div>
  );
};
